export default __webpack_public_path__ + "static/media/gallery-wip-flash-suppressor_04.44762dcf.jpg";